import { localize2 } from '../../../nls.js';
const Categories = ( (Object.freeze({
    View: ( localize2(4523, 'View')),
    Help: ( localize2(4524, 'Help')),
    Test: ( localize2(4525, 'Test')),
    File: ( localize2(4526, 'File')),
    Preferences: ( localize2(4527, 'Preferences')),
    Developer: ( localize2(4528, "Developer")),
})));
export { Categories };
